jQuery(document).ready(function($) {
  
  // BEST SELLERS PRODUCT SLIDER
  $('.Best_Sellers_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 850,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

  // CUSTOMER REVIEWS SLIDER
  $('.testimonials-slider').slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  });

  // ACCONT PAGE ANCHOR SCROLL
  $(document).on('click', '.customer.register a[href^="#"]', function (event) {
      event.preventDefault();
  
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top -125
      }, 500);
  });
});

// PRODUCT PAGE READ MORE/READ LESS BUTTON
var $this = $(".Product_Ingredients ul");
if ($this.find("li").length > 5) {
  $(".Product_Ingredients ul").after(
    '<div class="read_btn"><a href="javascript:;" class="more-less readMore"></a></div>'
  );
}
$(".Product_Ingredients ul li").slice(0, 5).addClass("shown");
$(".Product_Ingredients ul li").not(".shown").hide();
$(".Product_Ingredients .readMore").on("click", function () {
  $(".Product_Ingredients ul li").not(".shown").fadeToggle("slow");
  $(this).toggleClass("readLess");
});
